/**
 * Enum for unit visibility states
 * @readonly
 * @enum {string|boolean}
 */
export const UnitsVisibility = {
    /** No units are visible */
    NONE: false,
    /** All units are visible */
    ALL: 'all',
    /** Units in selected area plus included/excluded overlay (excluded still shown in area) */
    AREA: 'area',
    /** Only units that belong to the district selection (no excluded-unit overlay) */
    AREA_STRICT: 'area_strict'
};

/**
 * Type guard to check if a value is a valid UnitsVisibility state
 * @param {any} value - The value to check
 * @returns {boolean} True if the value is a valid UnitsVisibility state
 */
export const isValidUnitsVisibility = (value) => {
    return Object.values(UnitsVisibility).includes(value);
};

export default UnitsVisibility; 